module.exports = __webpack_public_path__ + "static/media/stripe-create-account_1.0a6f35b5.png";